<template>
	<div style="height:700px; width:1000px;">
		<table class="list_tbl">
			<thead>
				<tr>
					<th width="250px;">Item Code</th>
					<th width="95px;">PO No</th>
					<th width="100px;">PO Date</th>
					<th width="70px;">PO Qty</th>
					<th width="95px;">SH No</th>
					<th width="80px;">SH Qty</th>
					<th width="100px;">Arrival Date</th>
					<th>Status</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(s, index) in statuses" v-bind:key="index">
					<td class="al_left">
						<template v-if="index == 0 || (index > 0 && s.item_code != statuses[index - 1].item_code)">
							{{ s.item_code }}
						</template>
					</td>
					<td class="al_left">
						<template v-if="index == 0 || (index > 0 && s.po_dn != statuses[index - 1].po_dn)">
							{{ s.po_dn }}
						</template>
					</td>
					<td class="al_left">
						<template v-if="index == 0 || (index > 0 && s.po_dn != statuses[index - 1].po_dn)">
							{{ s.po_date }}
						</template>
					</td>
					<td class="al_right">
						<template v-if="index == 0 || (index > 0 && s.po_dn != statuses[index - 1].po_dn)">
							{{ s.po_quantity | commaSeparated }}
						</template>
					</td>
					<td class="al_left">{{ s.sh_dn }}</td>
					<td class="al_right">{{ s.quantity | commaSeparated }}</td>
					<td class="al_left">{{ s.arrival_date }}</td>
					<td class="al_left">{{ s.status }}</td>
				</tr>
			</tbody>
		</table>

		<div class="popup_bottom">
			<a href="javascript:;" @click="closeModal()" class="gray_bt">Close</a>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
import { apiSelectPOStatus } from '@/api/purchase/purchase';

export default {
	data: function() {
		return {
			statuses: [],
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	props: {
		item_id: String,
	},
	components: {
		// ItemClassSelect,
		// Modal,
		// ItemClassPopup,
		// AC,
	},
	methods: {
		close() {
			this.$emit('close');
		},
		closeModal() {
			this.$emit('close');
		},
		async init() {
			const { data } = await apiSelectPOStatus({ item_id: this.item_id });
			this.statuses = data.statusList;

			//console.log(this.statuses);
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
